var render, staticRenderFns
import script from "./SettingsBase.vue?vue&type=script&lang=js"
export * from "./SettingsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('801f6910')) {
      api.createRecord('801f6910', component.options)
    } else {
      api.reload('801f6910', component.options)
    }
    
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsBase.vue"
export default component.exports